'use client';
export {
  createCheckboxScope,
  //
  Checkbox,
  CheckboxIndicator,
  //
  Root,
  Indicator,
} from './Checkbox';
export type { CheckboxProps, CheckboxIndicatorProps, CheckedState } from './Checkbox';
